import { LoginResult } from '@models/AuthModel'
import { Employee } from '@models/Employee'
import { APIResponse } from '@supplement-bacon/react-toolkit/models'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import {
  LOGGED_USER_URL,
  LOGIN_URL,
  LOGOUT_URL,
  REQUEST_MAGIC_LINK_URL,
} from '@utils/urls'
import qs from 'qs'

const requestLoginMagicLink = (email: string, returnTo: string | null) =>
  SBAPI.Fetch<{}>(REQUEST_MAGIC_LINK_URL, {
    email,
    returnTo,
  })

const login = (
  expires: string | null,
  token: string | null,
  returnTo: string | null,
  signature: string | null
) =>
  SBAPI.Post<never, APIResponse<LoginResult>>(
    `${LOGIN_URL}?${qs.stringify({ expires, token, returnTo, signature })}`
  )

const logout = () => SBAPI.Post(LOGOUT_URL)

const getLoggedUserInfos = () => SBAPI.Fetch<Employee>(LOGGED_USER_URL)

export { getLoggedUserInfos, login, logout, requestLoginMagicLink }
